/**
 * Gender helpers for tickets (Lloyd, 31 Oct 2026: "For gender—just do male / female. I don't need
 * the 'other.' Nor do I need any pronoun options anywhere in the system.").
 */
export type TicketGender = 'male' | 'female' | '';
export type PronounSet = 'he_him' | 'she_her' | 'they_them' | '';

export const PRONOUN_SET_OPTIONS: { value: PronounSet; label: string }[] = [];

export function defaultPronounSetForGender(_gender: TicketGender): PronounSet {
  return '';
}

export function genderRequiresPronounSelection(_gender: TicketGender): boolean {
  return false;
}

export function isGenderPronounValid(
  gender: string | null | undefined,
  _pronounSet?: string | null | undefined,
): boolean {
  const normalized = (gender ?? '').trim().toLowerCase();
  return normalized === '' || normalized === 'male' || normalized === 'female';
}

export function formatGenderLabel(gender: string | null | undefined): string {
  const normalized = (gender ?? '').trim().toLowerCase();
  if (normalized === 'male') return 'Male';
  if (normalized === 'female') return 'Female';
  return 'Not specified';
}

export function formatPronounSetLabel(
  _pronounSet: string | null | undefined,
): string {
  return '';
}
